import React, { useEffect, useState } from "react";

const images = [
  "/images/pizzaspromo_1.jpeg",
  "/images/pizzaspromo_2.jpeg",
  "/images/pizzaspromo_3.jpeg",
  "/images/pizzaspromo_4.jpeg",
  "/images/pizzaspromo_5.jpeg"
];


const FooterCarousel = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '2rem 0', minHeight: '220px' }}>
      <img
        src={images[current]}
        alt={`promo ${current + 1}`}
        style={{
          width: '100%',
          maxWidth: '600px',
          maxHeight: '220px',
          objectFit: 'cover',
          borderRadius: '18px',
          background: '#222',
          boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
          transition: 'opacity 0.7s',
          opacity: 1
        }}
      />
    </div>
  );
};

export default FooterCarousel;
